import { MDBBreadcrumb, MDBBreadcrumbItem, MDBCol, MDBScrollspy, MDBScrollspyLink } from "mdb-react-ui-kit";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBRow,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";

import AAGeneralSettings from "../components/editviews/aagroup/AAGeneralSettings";


function DirectoriesSettings() {
    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const containerRef = useRef(null);

    const [basicActive, setBasicActive] = useState("tab1");
    const location = useLocation();
    const navigate = useNavigate();

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };




    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleShow12 = () => setAddNumbers(!AddNumbers);


    const ref = useRef(null);
    const [AAGInfo, setAAGInfo] = useState(
        location.state ? location.state : {}
    );
    const [aagcode, setaagcode] = useState('');
    const [grptitle, setGrpTitle] = useState('');
    const [aaextension, setAAExtension] = useState('');
    async function fetchAAGroupData() {
        const response = await getSpecificAAGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, AAGInfo.code);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        setAAGInfo(rawData);
        setaagcode(AAGInfo.code);
        setGrpTitle(AAGInfo.title);
        setAAExtension(AAGInfo.extensions)
    }


    const getSpecificAAGroup = {
        columns: [
            { label: "Name", field: "name" },
            { label: "Extension", field: "extension" },
            { label: "Remove", field: "delete" },
        ],
        rows: [
            {
                name: "Nick Leyendcker",
                extension: "3755",
                delete: <MDBIcon fas icon="times" color="primary" className="ms-3 cursor-pointer" />
            },
            {
                name: "Nick Leyendcker",
                extension: "3755",
                delete: <MDBIcon fas icon="times" color="primary" className="ms-3 cursor-pointer" />
            }
        ]
    }



    const [verticalActive, setVerticalActive] = useState('tab1');

    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
    };


    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={123}
                    content={
                        <>
                            <section>
                                <div className="card card-height">

                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a href="/huntgroup">
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a href="/pslanding">
                                                        <strong>{t("AutoAttendants")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong>Main Open AA</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>

                                            </MDBBreadcrumb>
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="pb-2">
                                            <h5 className="mt-2 ">
                                                Main Open AA
                                            </h5>
                                            <p className="mt-2 text-secondary">
                                                Extension: 5000
                                            </p>
                                            <h6 className="mt-2">
                                                <strong className="mt-3 mb-0">Associated Call Flow</strong>
                                                <p className="mt-2">
                                                    Main: 1000
                                                </p>
                                            </h6>
                                        </div>







                                        <MDBTabs className="mb-3 ">
                                            <MDBTabsItem>
                                                <MDBTabsLink
                                                    onClick={() => handleBasicClick("tab1")}
                                                    active={basicActive === "tab1"}
                                                >
                                                    {t("settings")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink
                                                    onClick={() => handleBasicClick("tab2")}
                                                    active={basicActive === "tab2"}
                                                >
                                                    {t("directories")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent className="p-0">
                                            <MDBTabsPane open={basicActive === "tab1"}>
                                                {/* Tab 1 content */}
                                                <MDBRow>
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg-2
                                                        sm="9"
                                                        className="col-sm-100 leftTabs"
                                                    >


                                                        <MDBTabs className="flex-column text-center">
                                                            <MDBTabsItem>
                                                                <MDBTabsLink
                                                                    className=""
                                                                    href="#general"
                                                                    onClick={() => handleVerticalClick("tab1")}
                                                                    active={verticalActive === "tab1"}
                                                                >
                                                                    {t("general")}
                                                                </MDBTabsLink>
                                                            </MDBTabsItem>

                                                            <MDBTabsItem>
                                                                <MDBTabsLink
                                                                    className=""
                                                                    href="#routing"
                                                                    onClick={() => handleVerticalClick("tab2")}
                                                                    active={verticalActive === "tab2"}
                                                                >
                                                                    {t("routing")}
                                                                </MDBTabsLink>
                                                            </MDBTabsItem>


                                                        </MDBTabs>
                                                    </MDBCol>
                                                    <MDBCol size="11" md="9" sm-9 className="col-sm-100 leftTabContent">
                                                        <div className="vtabHeight">
                                                            <div className="general-settings"
                                                                id="general">
                                                                <AAGeneralSettings
                                                                    ref={ref}
                                                                    AAGInfo={AAGInfo}
                                                                    AAGcode={aagcode}
                                                                />

                                                            </div>

                                                            <div className="routing-border"></div>

                                                            <div id="routing">
                                                                <h5 className="mb-0">
                                                                    <div className="general-settings" id="general">
                                                                        {t("routing")}
                                                                    </div>
                                                                </h5>
                                                                <span className="phrecording">
                                                                    {t("routingtxt")}
                                                                </span>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 0</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing color-black"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            Operation Hunt: 2500: Hunt Group
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 1</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select  selectname-routing color-black"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            Sales: 5755: Hunt Group
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 2</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select  selectname-routing color-black"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="8005569874">8005569874</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                    <div className="routing-check">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="routing-checks"
                                                                        />
                                                                        {t("callerIDtxt")}
                                                                    </div>
                                                                    <div className="d-flex space-between width-100">
                                                                        <div>
                                                                            <select className="form-control form-select selectname routing-search"
                                                                                name="San Jose"
                                                                            >
                                                                                <option value="San Jose">
                                                                                    {t("search")}..
                                                                                </option>
                                                                                <option value="San Jose">San Jose</option>
                                                                                <option value="San Jose">San Jose</option>
                                                                                <option value="San Jose">San Jose</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="form">
                                                                            <MDBBtn
                                                                                className="ms-2"
                                                                                onClick={toggleShow12}
                                                                            ><MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                                                                            </MDBBtn>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 3</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 4</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 5</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 6</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 7</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 8</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} 9</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} *</div>
                                                                <div className="phoneselect width-100 select_110">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="add-numbermain routing-border  p-2">
                                                                <div className="tel-numbers">{t("press")} #</div>
                                                                <div className="phoneselect width-100 select_110huntaccinfo">
                                                                    <select className="form-control form-select selectname-routing"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            {t("searchExtNo")}..
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === "tab2"} className="p-1">
                                                <MDBRow>
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg="2"
                                                        sm="12"
                                                        className="col-sm-100 pr-0 leftTabs"
                                                    >
                                                        <MDBScrollspy container={containerRef}>
                                                            <MDBScrollspyLink targetRef={section1}>{t("general")}</MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section2}>{t("users")}</MDBScrollspyLink>
                                                        </MDBScrollspy>
                                                    </MDBCol >


                                                    <MDBCol size="12" md="10" sm="12" pr-0 className="col-sm-100 pr-0 leftTabContent">
                                                        <div className="vtabHeightHunt pr-5">
                                                            <div id='element' ref={containerRef} className='scrollspy-example'>

                                                                <section ref={section1} id='section-1'>
                                                                    <h5 className="mb-0">
                                                                        <div className="general-settings" id="general">
                                                                            {t("general")}
                                                                        </div>
                                                                    </h5>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            {t("DirectoryName")}
                                                                        </div>

                                                                        <div className="form width-100 ">
                                                                            <input className="form-control" type="text" value="OpenAA NO CALL" />
                                                                        </div>
                                                                    </div>


                                                                    <div className="add-numbermain-small">
                                                                        <div>
                                                                            <div className="add-numbermain">
                                                                                <span className="fw-500">
                                                                                    {t("autoAttendantGreeting")}
                                                                                </span>
                                                                                <div className="phoneselect width-100">
                                                                                    <select className="form-control form-select selectname"
                                                                                        name="All Users"
                                                                                    >
                                                                                        <option value="San Jose">Exclude List</option>
                                                                                        <option value="San Jose">San Jose</option>
                                                                                        <option value="San Jose">San Jose</option>
                                                                                        <option value="San Jose">San Jose</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <span className="text-secondary">
                                                                                {t("autoAttendantGreetingtxt")}
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </section>
                                                                <div className="routing-border mt-2"></div>
                                                                <section ref={section2} id='section-2'>
                                                                    <h5 className="mb-0 add-numbermain">
                                                                        <div className="general-settings" id="general">
                                                                            {t("users")}
                                                                        </div>
                                                                        <MDBBtn><MDBIcon fas icon="plus" size="sm" className="me-2" />{t("addusers")}</MDBBtn>
                                                                    </h5>

                                                                    <MDBDatatable data={getSpecificAAGroup} sortField="Name" />


                                                                </section>

                                                            </div>
                                                        </div>
                                                    </MDBCol>

                                                </MDBRow>


                                            </MDBTabsPane>

                                        </MDBTabsContent>



                                    </div>


                                </div>
                            </section>
                        </>
                    }
                />
            </>
        </React.Fragment >
    )
}
export default DirectoriesSettings